import React from "react";

import Login from "./Login";

export default function () {
  return (
    <div>
      <Login />
    </div>
  );
}
